import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllBanners } from '../../store/actions/bannerAction'
import Layout from '../../components/Layout'
import { Button, Container } from '@mui/material'
import BasicModal from '../../components/modal/BasicModal'
import AddBanner from '../../components/banner/AddBanner'
import { checkUserRole } from '../../common/checkUserRole'
import { roleListId, roleType } from '../../config/roleList'
import BannerList from '../../components/banner/BannerList'

const Banners = () => {
    const dispatch = useDispatch()
    const { banners } = useSelector((state) => state.banner)
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        dispatch(getAllBanners())
    }, [dispatch])

    return (
        <Layout>
            <Container>
                <BasicModal open={open} setOpen={setOpen}>
                    <AddBanner setOpen={setOpen} />
                </BasicModal>

                <Button
                    color="info"
                    variant="outlined"
                    style={{ marginBottom: '20px' }}
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.BANNER,
                            roleType.CREATE
                        )
                            ? setOpen(true)
                            : alert('Not Permit User')
                    }
                >
                    Add New Banner
                </Button>
                <div style={{ padding: '20px' }} />
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {banners?.map((banner) => (
                        <BannerList key={banner.id} banner={banner} />
                    ))}
                </div>
            </Container>
        </Layout>
    )
}

export default Banners
